import { render, staticRenderFns } from "./StepThree.vue?vue&type=template&id=6ccf8a1f&scoped=true&lang=pug&"
import script from "./StepThree.vue?vue&type=script&lang=js&"
export * from "./StepThree.vue?vue&type=script&lang=js&"
import style0 from "./StepThree.vue?vue&type=style&index=0&id=6ccf8a1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf8a1f",
  null
  
)

export default component.exports